/**
 * Whether a media query matches now, and again whenever it changes. For the few places that must
 * render a different structure rather than a different style: a menu in place of a row of buttons
 * leaves one set of controls in the tab order instead of two.
 */
import { useSyncExternalStore } from "react";

export function useMedia(query: string): boolean {
  const subscribe = (notify: () => void) => {
    const list = window.matchMedia(query);

    list.addEventListener("change", notify);

    return () => list.removeEventListener("change", notify);
  };

  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
}
